import anime from 'animejs';

const calculateButton = document.getElementById('calculate');
const product = document.getElementById('product');
const guests = document.getElementById('guests');
const drinks = document.getElementById('drinks');
const calculateAgainButtons = document.querySelectorAll('.calculator__calculate-again');
const inputCards = document.querySelectorAll('.calculator__input-item');
const formContainer = document.querySelector('.calculator__form-container');
const errorEl = document.querySelector('.calculator__error');

//
// these next three functions are the ones hooked up to event listeners
// (the sort of highest level functions)
//

const calculate = () => {
    hideError();
    if (!guests.value) {
        showError('Please enter in the number of guests.');
        return;
    }
    if (!drinks.value) {
        showError('Please enter in the number of drinks.');
        return;
    }

    const productCards = document.querySelectorAll(
        `[data-id="${product.value}"] .calculator__product-item`
    );

    const onComplete = () => {
        formContainer.classList.add('calculator__form-container--hidden');
        const resultsDiv = document.querySelector(`[data-id="${product.value}"]`);
        resultsDiv.classList.add('calculator__results-container--visible');
        animateIn(productCards);
        removeTransformations(inputCards, calculateButton);
    };
    animateOut(inputCards, calculateButton, onComplete);

    productCards.forEach((card, i) => {
        const ounces = parseInt(card.getAttribute('data-size'));
        const number = getNumber(drinks.value, guests.value, ounces);
        const copy = getCopy(number, ounces, i, productCards.length);
        const copyEl = card.querySelector('.calculator__product-caption');
        copyEl.innerHTML = copy;
    });
};

const calculateAgain = () => {
    const productCards = document.querySelectorAll(
        '.calculator__results-container--visible .calculator__product-item'
    );
    const calculateAgainButton = document.querySelector(
        '.calculator__results-container--visible .calculator__calculate-again'
    );
    const visibleProductContainer = document.querySelector(
        '.calculator__results-container--visible'
    );
    const onComplete = () => {
        formContainer.classList.remove('calculator__form-container--hidden');
        visibleProductContainer.classList.remove(
            'calculator__results-container--visible'
        );
        animateIn(inputCards);
        removeTransformations(productCards, calculateAgainButton);
    };
    animateOut(productCards, calculateAgainButton, onComplete);
};

// function to ensure a user cannot input values outside specified range
const checkMinMax = (e) => {
    const min = parseInt(e.target.min);
    const max = parseInt(e.target.max);
    const value = parseInt(e.target.value);

    if (isNaN(value)) {
        e.target.value = min;
    } else if (value < min) {
        e.target.value = min;
    } else if (value > max) {
        e.target.value = max;
    }
};

//
// these "helper" functions are used within the three higher-level functions
// immediately above
//

const animateOut = (cards, button, callback) => {
    anime({
        targets: button,
        opacity: 0,
        easing: 'linear',
        duration: 200
    });

    anime({
        targets: cards,
        scale: 0.25,
        rotate: -45,
        duration: 300,
        opacity: 0,
        delay: anime.stagger(150),
        easing: 'linear',
        complete: callback
        // callback should be a function that trigger the animateIn
    });
};

const animateIn = (cards) => {
    const userPos = window.pageYOffset;
    const calcSection = document.querySelector('.calculator__top-copy');
    const topOfBox = userPos + calcSection.getBoundingClientRect().top;
    const headerHeight = document.querySelector('header').offsetHeight;

    if (userPos > topOfBox) {
        window.scrollTo({ top: topOfBox - headerHeight, behavior: 'smooth' });
    }

    anime({
        targets: cards,
        translateY: [100, 0],
        delay: anime.stagger(150)
    });

    anime({
        targets: cards,
        opacity: [0, 1],
        duration: 300,
        delay: anime.stagger(150),
        easing: 'linear'
    });
};

// resets the transformations from anime.js, but adds the opacity: 0
// back in when necessary
const removeTransformations = (cards, button) => {
    cards.forEach((card) => {
        card.removeAttribute('style');
        card.setAttribute('style', 'opacity: 0');
    });
    button.removeAttribute('style');
};

const getNumber = (drinks, guests, oz) => {
    return Math.ceil((guests * (drinks * 4)) / oz);
};

const getCopy = (number, size, index, total) => {
    let beginning, container, ending;

    // set beginning
    if (index === 0) {
        beginning = "You'll need";
    } else {
        beginning = 'or';
    }

    // set container copy
    switch (size) {
        case 59:
            container = '1.75L bottle';
            break;
        case 32:
            container = '32oz bottle';
            break;
        case 8:
            container = 'can';
    }

    if (number !== 1) {
        container = container.concat('s');
    }

    // set ending
    if (index + 1 === total) {
        ending = '! Cheers!';
    } else {
        ending = '…';
    }

    const finalCopy = `${beginning} ${number.toString()} ${container}${ending}`;
    return finalCopy;
};

const hideError = () => {
    errorEl.classList.remove('calculator__error--visible');
};

const showError = (msg) => {
    errorEl.classList.add('calculator__error--visible');
    errorEl.innerHTML = msg;
};

//
// event listeners
//

if (calculateButton) {
    calculateButton.addEventListener('click', calculate);
}

if (calculateAgainButtons.length > 0) {
    Array.from(calculateAgainButtons).forEach(function (el) {
        el.addEventListener('click', calculateAgain);
    });
}

if (guests) {
    guests.addEventListener('blur', (e) => checkMinMax(e));
}
if (drinks) {
    drinks.addEventListener('blur', (e) => checkMinMax(e));
}

// if the calculator is on a single product page, query WHICH page and then
// auto-select the mix from the first input field of the calculator

if (document.querySelector('.single-products')) {
    // isolate post-id by finding data attribute in main tag
    const pageId = document.querySelector('main').getAttribute('data-page-id');

    if (pageId) {
        // pulls the option elements from the #product dropdown, puts their values
        // (in this case, page IDs) into an array
        const options = Array.from(document.querySelectorAll('#product option'));
        const optionsNumArr = options.map((opt) => opt.value);

        // if the current page's ID is a value in the dropdown, set the selected
        // dropdown value to it
        if (optionsNumArr.includes(pageId)) {
            product.value = pageId;
        }
    }
}
